import React from "react";
import { createRoot } from "react-dom/client";
import TreeOfLife from "./TreeOfLife";

// The payload is embedded in the page, so there is no fetch and no loading
// state — the tree renders on first paint.
export function mount(element) {
  if (!element || element.dataset.mounted === "true") return;
  const tree = JSON.parse(element.dataset.tree);
  element.dataset.mounted = "true";
  createRoot(element).render(<TreeOfLife tree={tree} />);
}

function mountAll() {
  document.querySelectorAll("#tree-of-life").forEach(mount);
}

document.addEventListener("DOMContentLoaded", mountAll);
// Turbo swaps the body without a fresh DOMContentLoaded.
document.addEventListener("turbo:load", mountAll);
